// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import {
    chain,
    DispatchCompleteCancelOrder,
} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/CancelOrder";

export const CustomDispatchCompleteCancelOrder: typeof DispatchCompleteCancelOrder = props => {
    props.dispatch({
        type: "Pages/OrderDetails/CompleteCancelOrder",
    });
    props.dispatch(
        loadOrderByOrderNumber({
            orderNumber: props.apiResult.erpOrderNumber || props.apiResult.webOrderNumber,
            expand: props.apiResult.vmiLocationId
                ? ["orderLines", "shipments", "vmidetails"]
                : ["orderLines", "shipments"],
        }),
    );
};

replaceInChain(chain, DispatchCompleteCancelOrder, CustomDispatchCompleteCancelOrder);
